// import dayjs from "dayjs"; // riabilitare insieme al cross-field check obsolescent>publish
import { ActivityWizardData } from "../../../types";
import { DIGITED_CODE_MAX_LENGTH } from "../../../../constants";
import { MAIN_INFO_BY_TYPE } from "../config/mainInfoTypeConfig";
import { ValidationResult } from "@components/WizardCst/types";

const isEmpty = (value: unknown): boolean => {
  if (value === null || value === undefined) return true;
  if (typeof value === "string") return value.trim().length === 0;
  if (typeof value === "object" && value !== null && "id" in value) {
    return !(value as { id: unknown }).id;
  }
  return false;
};

export const validateMainInfo = (
  data: ActivityWizardData,
): ValidationResult => {
  const errors: Record<string, string> = {};

  if (!data.type) {
    return { valid: false, errors: {} };
  }

  const config = MAIN_INFO_BY_TYPE[data.type];

  for (const field of config.requiredFields) {
    if (isEmpty(data[field as keyof ActivityWizardData])) {
      errors[field] = "required";
    }
  }

  if (data.title && data.title.length > 70) errors.title = "too-long";
  if (data.detail_description && data.detail_description.length > 256)
    errors.detail_description = "too-long";
  if (data.digited_code && data.digited_code.length > DIGITED_CODE_MAX_LENGTH)
    errors.digited_code = "too-long";

  if (data.is_standalone) {
    if (data.schedule_publication && isEmpty(data.publish_date)) {
      errors.publish_date = "required";
    }
    if (data.schedule_obsolescence && isEmpty(data.obsolescent_date)) {
      errors.obsolescent_date = "required";
    }

    // 3. Cross-field: obsolescent_date > publish_date strict
    // if (data.publish_date && data.obsolescent_date) {
    //   const obs = dayjs(data.obsolescent_date);
    //   const pub = dayjs(data.publish_date);
    //   if (obs.isBefore(pub) || obs.isSame(pub)) {
    //     errors.obsolescent_date = "invalid-expiration-date";
    //   }
    // }
  }

  if (data.type === "DA_EXTERNAL_RES" && data.external_file_url) {
    if (!/^\d+$/.test(data.external_file_url)) {
      errors.external_file_url = "invalid-number";
    }
  }

  if (data.type === "DA_URL_RES" && data.external_file_url) {
    if (data.is_link_relative) {
      if (!data.external_file_url.startsWith("/")) {
        errors.external_file_url = "input-must-start-with-slash";
      }
    } else {
      if (!/^https?:\/\//.test(data.external_file_url)) {
        errors.external_file_url = "input-must-start-with-http";
      }
    }

    if (data.flag_authentication) {
      if (isEmpty(data.client_id)) errors.client_id = "required";
      if (isEmpty(data.client_secret)) {
        errors.client_secret = "required";
      } else if (data.client_secret.length < 32) {
        errors.client_secret = "too-short";
      }
    }
  }

  if (data.min_partecipant && data.max_partecipant) {
    const min = Number(data.min_partecipant);
    const max = Number(data.max_partecipant);
    if (Number.isFinite(min) && Number.isFinite(max) && max < min) {
      errors.min_partecipant = "participants-number-condition";
      errors.max_partecipant = "participants-number-condition";
    }
  }

  return { valid: Object.keys(errors).length === 0, errors };
};
